export default __webpack_public_path__ + "svg/ceo/digitization.svg?f198357d";